import { namespace } from 'vuex-class';
import { IAddResourceState } from './add-resource.types';

export const AddResource = namespace('documentManipulator/createPage/addResource');

export enum EAddResourceAction {
  AddToNewDocument = 'addToNewDocument',
  AddToDocument = 'addToDocument',
  AddToTemplate = 'addToTemplate',
  AddSuccess = 'addSuccess',
  AddFailed = 'addFailed',
  Reset = 'reset',
}

export enum EAddResourceMutation {
  SetState = 'setState',
  SetAdding = 'setAdding',
  SetResource = 'SetResource',
  SetDocumentId = 'SetDocumentId',
}

export const state: IAddResourceState = {
  adding: false,
  resource: null,
  documentId: null,
};
